/**
 * @generated SignedSource<<9e54a7ad75f320ac98f06c271b5c4375>>
 * @relayHash 84b4b6106c2a0f860020f17d20f24cdb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b6d697e546a3d24095235e802d3ba0010dc94c7fe06dad4f5d046973d963714a

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type TownsquareGoalSortEnum = "CREATION_DATE_ASC" | "CREATION_DATE_DESC" | "HIERARCHY_ASC" | "HIERARCHY_DESC" | "HIERARCHY_LEVEL_ASC" | "HIERARCHY_LEVEL_DESC" | "ID_ASC" | "ID_DESC" | "LATEST_UPDATE_DATE_ASC" | "LATEST_UPDATE_DATE_DESC" | "NAME_ASC" | "NAME_DESC" | "PHASE_ID_ASC" | "PHASE_ID_DESC" | "PROJECT_COUNT_ASC" | "PROJECT_COUNT_DESC" | "SCORE_ASC" | "SCORE_DESC" | "START_DATE_ASC" | "START_DATE_DESC" | "TARGET_DATE_ASC" | "TARGET_DATE_DESC" | "WATCHER_COUNT_ASC" | "WATCHER_COUNT_DESC" | "WATCHING_ASC" | "WATCHING_DESC" | "%future added value";
export type DirectoryViewAggTableQuery$variables = {
  after?: string | null;
  containerId: string;
  first?: number | null;
  searchString?: string | null;
  sort?: ReadonlyArray<TownsquareGoalSortEnum | null> | null;
};
export type DirectoryViewAggTableQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"DirectoryTableViewAgg">;
};
export type DirectoryViewAggTableQuery = {
  response: DirectoryViewAggTableQuery$data;
  variables: DirectoryViewAggTableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "containerId"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchString"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "sort"
},
v5 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "after"
  },
  {
    "kind": "Variable",
    "name": "containerId",
    "variableName": "containerId"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "first"
  },
  {
    "kind": "Variable",
    "name": "searchString",
    "variableName": "searchString"
  },
  {
    "kind": "Variable",
    "name": "sort",
    "variableName": "sort"
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 1
  }
],
v8 = [
  (v6/*: any*/)
],
v9 = {
  "kind": "ScalarField",
  "name": "key"
},
v10 = {
  "kind": "ScalarField",
  "name": "value"
},
v11 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 50
  }
],
v12 = {
  "kind": "ScalarField",
  "name": "name"
},
v13 = {
  "kind": "ScalarField",
  "name": "count"
},
v14 = {
  "kind": "ScalarField",
  "name": "hasNextPage"
},
v15 = {
  "kind": "ScalarField",
  "name": "uuid"
},
v16 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v17 = [
  {
    "kind": "ScalarField",
    "name": "token"
  }
],
v18 = {
  "kind": "InlineFragment",
  "selections": (v8/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v19 = [
  {
    "kind": "ScalarField",
    "name": "canSetMultipleValues"
  }
],
v20 = {
  "kind": "ScalarField",
  "name": "accountId"
},
v21 = {
  "kind": "ScalarField",
  "name": "picture"
},
v22 = {
  "kind": "ScalarField",
  "name": "url"
},
v23 = [
  (v9/*: any*/),
  (v6/*: any*/)
],
v24 = {
  "kind": "ScalarField",
  "name": "isArchived"
},
v25 = {
  "kind": "ScalarField",
  "name": "kind"
},
v26 = [
  (v10/*: any*/)
],
v27 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "messageId"
    },
    {
      "kind": "ScalarField",
      "name": "defaultValue"
    }
  ],
  "type": "TownsquareLocalizationField"
},
v28 = {
  "kind": "LinkedField",
  "name": "name",
  "plural": false,
  "selections": [
    (v16/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v26/*: any*/),
      "type": "TownsquareGoalTypeCustomName"
    },
    (v27/*: any*/)
  ]
},
v29 = {
  "kind": "ScalarField",
  "name": "type"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "DirectoryViewAggTableQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "kind": "FragmentSpread",
        "name": "DirectoryTableViewAgg"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v3/*: any*/),
      (v2/*: any*/),
      (v0/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "DirectoryViewAggTableQuery",
    "selections": [
      {
        "args": (v5/*: any*/),
        "concreteType": "TownsquareGoalConnection",
        "kind": "LinkedField",
        "name": "goals_search",
        "plural": false,
        "selections": [
          {
            "concreteType": "TownsquareGoalEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "TownsquareGoal",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v6/*: any*/),
                  {
                    "args": (v7/*: any*/),
                    "concreteType": "TownsquareGoalConnection",
                    "kind": "LinkedField",
                    "name": "subGoals",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": (v8/*: any*/)
                          }
                        ]
                      }
                    ],
                    "storageKey": "subGoals(first:1)"
                  },
                  (v9/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "latestUpdateDate"
                  },
                  {
                    "concreteType": "TownsquareGoalState",
                    "kind": "LinkedField",
                    "name": "state",
                    "plural": false,
                    "selections": [
                      (v10/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "score"
                      }
                    ]
                  },
                  {
                    "concreteType": "TownsquareTargetDate",
                    "kind": "LinkedField",
                    "name": "dueDate",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "confidence"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "label"
                      },
                      {
                        "concreteType": "TownsquareTargetDateRange",
                        "kind": "LinkedField",
                        "name": "dateRange",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "end"
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "TownsquareTagConnection",
                    "kind": "LinkedField",
                    "name": "tags",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareTagEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareTag",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "description"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "projectUsageCount"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "goalUsageCount"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "watcherCount"
                              }
                            ]
                          }
                        ]
                      },
                      (v13/*: any*/)
                    ],
                    "storageKey": "tags(first:50)"
                  },
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "TownsquareGoalTeamConnection",
                    "kind": "LinkedField",
                    "name": "teams",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalTeamEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TeamV2",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "displayName"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "smallAvatarImageUrl"
                              }
                            ]
                          }
                        ]
                      },
                      {
                        "concreteType": "PageInfo",
                        "kind": "LinkedField",
                        "name": "pageInfo",
                        "plural": false,
                        "selections": [
                          (v14/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "teams(first:50)"
                  },
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "TownsquareProjectConnection",
                    "kind": "LinkedField",
                    "name": "projects",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareProjectEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareProject",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v6/*: any*/),
                              (v9/*: any*/),
                              (v12/*: any*/),
                              (v15/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "isPrivate"
                              },
                              {
                                "concreteType": "TownsquareIconURIs",
                                "kind": "LinkedField",
                                "name": "iconUrl",
                                "plural": false,
                                "selections": [
                                  {
                                    "concreteType": "TownsquareThemeURIs",
                                    "kind": "LinkedField",
                                    "name": "square",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "kind": "ScalarField",
                                        "name": "light"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "dark"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "transparent"
                                      }
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "projects(first:50)"
                  },
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "TownsquareCustomFieldConnection",
                    "kind": "LinkedField",
                    "name": "customFields",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareCustomFieldEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v17/*: any*/),
                                        "type": "TownsquareNumberCustomFieldDefinition"
                                      },
                                      (v18/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "TownsquareNumberCustomField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v17/*: any*/),
                                        "type": "TownsquareTextCustomFieldDefinition"
                                      },
                                      (v18/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "TownsquareTextCustomField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v17/*: any*/),
                                        "type": "TownsquareTextSelectCustomFieldDefinition"
                                      },
                                      (v18/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v17/*: any*/),
                                        "type": "TownsquareUserCustomFieldDefinition"
                                      },
                                      (v18/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "TownsquareUserCustomField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldNumberSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "numberValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v6/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "TownsquareNumberCustomField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v19/*: any*/),
                                        "type": "TownsquareTextSelectCustomFieldDefinition"
                                      },
                                      (v18/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": (v11/*: any*/),
                                    "concreteType": "TownsquareCustomFieldTextSavedValueConnection",
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "concreteType": "TownsquareCustomFieldTextSavedValueEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v6/*: any*/),
                                              (v10/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "values(first:50)"
                                  }
                                ],
                                "type": "TownsquareTextSelectCustomField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "kind": "LinkedField",
                                    "name": "definition",
                                    "plural": false,
                                    "selections": [
                                      (v16/*: any*/),
                                      {
                                        "kind": "InlineFragment",
                                        "selections": (v19/*: any*/),
                                        "type": "TownsquareUserCustomFieldDefinition"
                                      },
                                      (v18/*: any*/)
                                    ]
                                  },
                                  {
                                    "args": (v11/*: any*/),
                                    "concreteType": "TownsquareUserConnection",
                                    "kind": "LinkedField",
                                    "name": "values",
                                    "plural": false,
                                    "selections": [
                                      (v13/*: any*/),
                                      {
                                        "concreteType": "TownsquareUserEdge",
                                        "kind": "LinkedField",
                                        "name": "edges",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "node",
                                            "plural": false,
                                            "selections": [
                                              (v16/*: any*/),
                                              (v20/*: any*/),
                                              (v12/*: any*/),
                                              (v21/*: any*/),
                                              (v6/*: any*/)
                                            ]
                                          }
                                        ]
                                      }
                                    ],
                                    "storageKey": "values(first:50)"
                                  }
                                ],
                                "type": "TownsquareUserCustomField"
                              },
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  {
                                    "concreteType": "TownsquareCustomFieldTextSavedValueNode",
                                    "kind": "LinkedField",
                                    "name": "value",
                                    "plural": false,
                                    "selections": [
                                      {
                                        "alias": "textValue",
                                        "kind": "ScalarField",
                                        "name": "value"
                                      },
                                      (v6/*: any*/)
                                    ]
                                  }
                                ],
                                "type": "TownsquareTextCustomField"
                              }
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "customFields(first:50)"
                  },
                  {
                    "kind": "LinkedField",
                    "name": "owner",
                    "plural": false,
                    "selections": [
                      (v16/*: any*/),
                      {
                        "kind": "TypeDiscriminator",
                        "abstractKey": "__isUser"
                      },
                      (v20/*: any*/),
                      (v12/*: any*/),
                      (v21/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseConnection",
                    "kind": "LinkedField",
                    "name": "focusAreas",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "GraphStoreSimplifiedFocusAreaHasAtlasGoalInverseEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": [
                                  (v15/*: any*/),
                                  (v12/*: any*/),
                                  (v22/*: any*/),
                                  {
                                    "concreteType": "MercuryFocusAreaStatus",
                                    "kind": "LinkedField",
                                    "name": "status",
                                    "plural": false,
                                    "selections": (v23/*: any*/)
                                  },
                                  {
                                    "concreteType": "MercuryFocusAreaHealth",
                                    "kind": "LinkedField",
                                    "name": "health",
                                    "plural": false,
                                    "selections": (v23/*: any*/)
                                  }
                                ],
                                "type": "MercuryFocusArea"
                              },
                              (v18/*: any*/)
                            ]
                          },
                          (v6/*: any*/)
                        ]
                      }
                    ],
                    "storageKey": "focusAreas(first:50)"
                  },
                  (v22/*: any*/),
                  (v24/*: any*/),
                  {
                    "concreteType": "TownsquareUserConnection",
                    "kind": "LinkedField",
                    "name": "watchers",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareUserEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v13/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareGoalCapabilities",
                    "kind": "LinkedField",
                    "name": "capabilities",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "canArchiveGoal"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canDeleteGoal"
                      },
                      {
                        "concreteType": "TownsquareGoalAppCapabilities",
                        "kind": "LinkedField",
                        "name": "apps",
                        "plural": false,
                        "selections": [
                          {
                            "kind": "ScalarField",
                            "name": "canCreateGoal"
                          }
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "canWatchGoal"
                      }
                    ]
                  },
                  (v12/*: any*/),
                  {
                    "concreteType": "TownsquareGoalType",
                    "kind": "LinkedField",
                    "name": "goalType",
                    "plural": false,
                    "selections": [
                      (v25/*: any*/),
                      {
                        "concreteType": "TownsquareGoalType",
                        "kind": "LinkedField",
                        "name": "successMeasure",
                        "plural": false,
                        "selections": [
                          (v28/*: any*/),
                          {
                            "kind": "LinkedField",
                            "name": "namePlural",
                            "plural": false,
                            "selections": [
                              (v16/*: any*/),
                              {
                                "kind": "InlineFragment",
                                "selections": (v26/*: any*/),
                                "type": "TownsquareGoalTypeCustomNamePlural"
                              },
                              (v27/*: any*/)
                            ]
                          },
                          (v6/*: any*/)
                        ]
                      },
                      (v6/*: any*/),
                      {
                        "concreteType": "TownsquareGoalTypeConnection",
                        "kind": "LinkedField",
                        "name": "allowedChildTypes",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoalTypeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "concreteType": "TownsquareGoalType",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v25/*: any*/),
                                  (v6/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v28/*: any*/)
                    ]
                  },
                  {
                    "args": (v11/*: any*/),
                    "concreteType": "TownsquareGoalConnection",
                    "kind": "LinkedField",
                    "name": "successMeasures",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareGoalEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareGoal",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              (v24/*: any*/),
                              (v6/*: any*/),
                              (v12/*: any*/),
                              {
                                "concreteType": "TownsquareStatus",
                                "kind": "LinkedField",
                                "name": "status",
                                "plural": false,
                                "selections": (v26/*: any*/)
                              },
                              (v16/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "successMeasures(first:50)"
                  },
                  {
                    "concreteType": "TownsquareGoal",
                    "kind": "LinkedField",
                    "name": "parentGoal",
                    "plural": false,
                    "selections": [
                      (v12/*: any*/),
                      (v6/*: any*/)
                    ]
                  },
                  {
                    "concreteType": "TownsquareGoalIcon",
                    "kind": "LinkedField",
                    "name": "icon",
                    "plural": false,
                    "selections": [
                      (v9/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "appearance"
                      }
                    ]
                  },
                  {
                    "concreteType": "TownsquareGoalProgress",
                    "kind": "LinkedField",
                    "name": "progress",
                    "plural": false,
                    "selections": [
                      (v29/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "percentage"
                      }
                    ]
                  },
                  {
                    "args": (v7/*: any*/),
                    "concreteType": "TownsquareMetricTargetConnection",
                    "kind": "LinkedField",
                    "name": "metricTargets",
                    "plural": false,
                    "selections": [
                      {
                        "concreteType": "TownsquareMetricTargetEdge",
                        "kind": "LinkedField",
                        "name": "edges",
                        "plural": true,
                        "selections": [
                          {
                            "concreteType": "TownsquareMetricTarget",
                            "kind": "LinkedField",
                            "name": "node",
                            "plural": false,
                            "selections": [
                              {
                                "concreteType": "TownsquareMetricValue",
                                "kind": "LinkedField",
                                "name": "snapshotValue",
                                "plural": false,
                                "selections": [
                                  (v10/*: any*/),
                                  (v6/*: any*/)
                                ]
                              },
                              {
                                "kind": "ScalarField",
                                "name": "startValue"
                              },
                              {
                                "kind": "ScalarField",
                                "name": "targetValue"
                              },
                              {
                                "concreteType": "TownsquareMetric",
                                "kind": "LinkedField",
                                "name": "metric",
                                "plural": false,
                                "selections": [
                                  {
                                    "kind": "ScalarField",
                                    "name": "archived"
                                  },
                                  (v29/*: any*/),
                                  {
                                    "kind": "ScalarField",
                                    "name": "subType"
                                  },
                                  (v6/*: any*/)
                                ]
                              },
                              (v6/*: any*/)
                            ]
                          }
                        ]
                      }
                    ],
                    "storageKey": "metricTargets(first:1)"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "isWatching"
                  },
                  (v15/*: any*/),
                  (v16/*: any*/)
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "endCursor"
              },
              (v14/*: any*/)
            ]
          }
        ]
      },
      {
        "args": (v5/*: any*/),
        "filters": [
          "containerId",
          "searchString",
          "sort"
        ],
        "handle": "connection",
        "key": "DirectoryTable__goals_search",
        "kind": "LinkedHandle",
        "name": "goals_search"
      }
    ]
  },
  "params": {
    "id": "b6d697e546a3d24095235e802d3ba0010dc94c7fe06dad4f5d046973d963714a",
    "metadata": {},
    "name": "DirectoryViewAggTableQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "42f196c8dd935af4a69439a12f1650cb";

export default node;
